<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        InfraPilot<br>
        星汉未来AI托管平台
      </a-typography-title>
      <a-typography-paragraph>
        {{
          '依托多项专利技术，无需改造即可实现AI应用与大模型推理的Serverless化。' +
          'InfraPilot支持分钟级应用部署、GPU/CPU自动调度、无人化运维以及自动化成本治理。' +
          '一站式管理企业内各类自研AI应用与大模型，构建高效的AI应用开发及大模型训练推理平台，显著提升研发效率。'
        }}
      </a-typography-paragraph>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'"> -->
        <!-- <a-button type="link" class="button_n_1"
                  @click="clickToCloud()">
          立即注册体验
        </a-button> -->
        <!--<a-button type="link" class="button_n_1"-->
        <!--          @click="localTo($Config.Href.github)">-->
        <!--  体验开源版-->
        <!--</a-button>-->
        <!--<a-button type="link" class="button_n_3"-->
        <!--          @click="$Store.Page().openModal('modalFormCollection', 'deployment')">-->
        <!--  预约私有化部署-->
        <!--</a-button>-->
      <!-- </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_banner',
  methods: {
    /**
     * 点击去云平台
     */
    clickToCloud(): void {
      // location.href = $Config.Href.cloud;
      open($Config.Href.cloud);
    },
    localTo(url: string): void {
      const newWindow = window.open(url, '_blank');
      newWindow.focus();
    },
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productInfraPilot/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 120px 0 50px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title+4px, @color_white, @banner_title, true);
  
  span {
    line-height: 30px;
    font-size: 30px;
  }
}

div.ant-typography {
  max-width: 650px;
  margin: 15px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin-top: 20px;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo+@line_mo, @color_white, @banner_title_mo, true);
    
    span {
      line-height: @banner_title_mo+@line_mo;
      font-size: @banner_title_mo;
    }
  }
  
  div.ant-typography {
    margin: 10px 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin-top: 10px;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>